
//frontend/src/components/EcoCalculatorPage/EcoCalculatorPage.jsx

// ============================================================
// Роли frontend
// ============================================================

const ROLES = {
  // ==========================================================
  // АДМИНИСТРАТОР
  // ==========================================================

  admin: {
    id: "admin",

    // Реальная Django-группа
    groups: ["administrators"],

    title: "Администратор",

    // После входа → DesktopPage
    defaultPath: "/",

    header: {
      logo: "⚙️",
      title: "Административная панель",
    },

    desktop: {
      title: "Рабочий стол администратора",
      description:
        "Управление системой, сотрудниками и настройками",
    },

    modules: [
      {
        id: "clients",
        title: "Сотрудники",
        icon: "👥",
        path: "/clients",
      },

      {
        id: "settings",
        title: "Настройки",
        icon: "⚙️",
        path: "/settings",
      },

      {
        id: "finance",
        title: "Финансы",
        icon: "💰",
        path: "/finance",
      },

      {
        id: "accounting",
        title: "Бухгалтерия",
        icon: "🧾",
        path: "/accounting",
      },

      {
        id: "orders",
        title: "Заказы",
        icon: "📋",
        path: "/orders",
      },


      {
        id: "request-search",
        title: "Заявка на поиск",
        icon: "🔎",
        path: "/request-search",
      },
      
      {
        id: "suppliers",
        title: "Поставщики",
        icon: "🏭",
        path: "/suppliers",
      },

      {
        id: "products",
        title: "Товары",
        icon: "📦",
        path: "/products",
      },

      {
        id: "expeditors",
        title: "Экспедиторы",
        icon: "🚚",
        path: "/expeditors",
      },

      {
        id: "tracking",
        title: "Трекинг",
        icon: "📍",
        path: "/tracking",
      },

      {
        id: "calendar",
        title: "Календарь",
        icon: "📅",
        path: "/calendar",
      },

      {
        id: "map",
        title: "Карта",
        icon: "🗺️",
        path: "/map",
      },

      {
        id: "procurement",
        title: "Закупки",
        icon: "🛒",
        path: "/procurement",
      },

      {
        id: "help",
        title: "Помощь",
        icon: "❓",
        path: "/help",
      },

      {
        id: "eco-calculator",
        title: "Калькулятор РОП",
        icon: "♻️",
        path: "/admin/eco-calculator",
      },


      {
        id: "users",
        title: "Пользователи",
        icon: "👤",
        path: "/users",
      },


    ],
  },

  // ==========================================================
  // МЕНЕДЖЕР ПО ЗАКУПКАМ
  // ==========================================================

  procurement_manager: {
    id: "procurement_manager",

    // Реальная Django-группа
    groups: ["procurement"],

    title: "Менеджер по закупкам",

    // После входа → ProcurementPage
    defaultPath: "/procurement",

    header: {
      logo: "🛒",
      title: "Закупки",
    },

    desktop: {
      title: "Рабочий стол закупок",
      description: "Работа с закупками",
    },

    // Доступ только к платформе Procurement.
    // Внутренние разделы:
    //
    // Обзор
    // Заявки
    // Поставщики
    // Календарь
    //
    // Они управляются внутри ProcurementPage.jsx
    // через ProcurementSidebar.

    modules: [
      {
        id: "procurement",
        title: "Закупки",
        icon: "🛒",
        path: "/procurement",
      },
    ],
  },

  // ==========================================================
  // МЕНЕДЖЕР ПО КЛИЕНТАМ
  // ==========================================================

  client_manager: {
    id: "client_manager",

    // Реальная Django-группа
    groups: ["client_managers"],

    title: "Менеджер по клиентам",

    // После входа → /clients
    defaultPath: "/clients",

    header: {
      logo: "👥",
      title: "Клиенты",
    },

    desktop: {
      title: "Рабочий стол менеджера",
      description:
        "Клиенты, коммуникация и работа с заказами",
    },

    modules: [
      {
        id: "clients",
        title: "Клиенты",
        icon: "👥",
        path: "/clients",
      },

      {
        id: "orders",
        title: "Заказы",
        icon: "📋",
        path: "/orders",
      },

      {
        id: "calendar",
        title: "Календарь",
        icon: "📅",
        path: "/calendar",
      },
    ],
  },
};

// ============================================================
// Получить роль frontend по Django groups
// ============================================================

export function getRoleFromGroups(groups = []) {
  if (!Array.isArray(groups)) {
    return null;
  }

  for (const role of Object.values(ROLES)) {
    const hasRole = role.groups?.some((group) =>
      groups.includes(group)
    );

    if (hasRole) {
      return role;
    }
  }

  return null;
}

// ============================================================
// Найти модуль роли по ID
// ============================================================

export function getModuleById(role, moduleId) {
  if (!role || !moduleId) {
    return null;
  }

  return (
    role.modules?.find(
      (module) => module.id === moduleId
    ) || null
  );
}

// ============================================================
// Проверить право доступа к модулю
// ============================================================

export function hasModuleAccess(role, moduleId) {
  return Boolean(
    getModuleById(role, moduleId)
  );
}

// ============================================================
// Проверить, может ли роль открыть конкретный URL
// ============================================================

export function canAccessPath(role, pathname) {
  if (!role || !pathname) {
    return false;
  }

  return role.modules.some((module) => {
    return (
      pathname === module.path ||
      pathname.startsWith(`${module.path}/`)
    );
  });
}

// ============================================================
// Получить разрешённые пути роли
// ============================================================

export function getAllowedPaths(role) {
  if (!role) {
    return [];
  }

  return role.modules.map(
    (module) => module.path
  );
}
